import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormBuilder, FormsModule} from "@angular/forms";
import {SwitchBoard} from "../../services/SwitchBoard";
import {LoadingService} from "../../services/LoadingService";
import {ActivatedRoute, Router} from "@angular/router";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {ToastService} from "../../services/Toast.service";
import {StateService} from "../../services/StateService";
import {NgxScrollEvent} from "../../directives/ngx-scroll-event.directive";
import {LoginService} from "../../services/Login.service";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {State} from "../../models/State";
import {Session} from "../../services/Session";
import {PageTitleService} from "../../services/PageTitle";
import {environment} from "../../../environments/environment";
import {TasksService} from "../../services/Tasks.service";
import {DateFormater} from "../../services/DateFormatter.service";
import {ExportService} from "../../services/Export.service";
import {TrackerPaginatedTableComponent} from "../../tables/tracker-paginated-table/tracker-paginated-table.component";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import {takeUntil} from "rxjs/operators";
import {FoundationInit} from "../../directives/foundation.directive";
import {TpiqCustomDatepicker} from "../../directives/tpiq-custom-datepicker";

declare let jQuery: any;
declare let _: any;
declare let moment: any;
@Component({
  selector: 'app-tasks-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, NgMultiSelectDropDownModule, TrackerPaginatedTableComponent, TpiqSelectDropdownComponent, FoundationInit, TpiqCustomDatepicker],
  templateUrl: './tasks-dashboard.component.html',
  styleUrl: './tasks-dashboard.component.scss'
})
export class TasksDashboardComponent {
  dateFormat: string;
  companiesList: Array<any> = [];
  clientCompaniesList: Array<any> = [];
  contactsList: Array<any> = [];
  groupedCompanies: any = {};
  companiesToSearch: Array<any> = [];
  tasksDays: Array<any> = [{id: 'All', name: 'All'}, {id: 'Snapshot', name: 'Next 60 days'}, {
    id: 'Next 7 days',
    name: 'Next 7 days'
  }, {id: 'Next 30 Days', name: 'Next 30 Days'}, {id: 'Past Due', name: 'Past Due'}, {id: 'Custom', name: 'Custom'}];
  showGridView: boolean;
  showListView = true;
  pastDueCount = 0;
  next60DaysCount = 0;
  dueTodayCount = 0;
  pastDue: Array<any> = [];
  next60Days: Array<any> = [];
  dueToday: Array<any> = [];
  users: Array<any> = [];
  taskDisplay: any;
  selectedValues: Array<any> = [];
  serviceDateformat: string;
  editTask: any;
  data: any;
  filterObj: any = {date: '', status: '', assignees: '', company: '', type: '', fromDate: '', toDate: ''};
  oldFilterObj: any = {date: '', status: '', assignees: '', company: '', type: '', fromDate: '', toDate: ''};
  isShowAll = true;
  badgeText = '';
  totalCount = 0;
  isAssigneeSelect = false;
  assigneeName: string;
  showNoRecords = true;

  hasBaseDropZoneOver = false;
  document: any;
  attachments: Array<any> = [];
  sourceId: string;
  postId: string;
  onTaskCreateSubscribe: any;
  taskId: string;
  routeSub: any;
  routeSubscribe: any;
  count = 0;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  selectedWorkflows = [];
  multiselectReady = false;

  statusdropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  selectedStatuses = [];
  selectedStatus = [];

  companydropdownSettings = {
    singleSelection: false,
    idField: 'name',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  selectedCompanies = [];
  selectedCompany = [];

  assigneedropdownSettings = {
    singleSelection: false,
    idField: 'email',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  selectedAssignees = [];
  selectedAssignee = [];
  assignedName = [];

  user: string;

  allTasksList: Array<any> = [];
  onClearFilter: any;

  tasksTableData: any = {};
  hasTasks = false;
  isLoading = false;
  tasksSort: any = {};
  nextIndex = 0;
  hasNextSet = false;

  tasksLoading = false;
  allTasksLoaded: boolean;
  taskIndex = 0;

  showMessage = true;
  updateObjState: any;
  displayCompanies: Array<any> = [];
  displayUsers: Array<any> = [];

  recurringState = false;
  tax: boolean;
  editingCompany = false;

  splitPage = false;
  pageWidth = '37%';
  navigate = true;
  viewEditTask: boolean;
  onTaskEditSubscribe: any;
  onTaskSearchSubscribe: any;
  searchText = '';
  org: string;
  clearSub: any;
  orgTypes: Array<any> = [];

  onNewCompanySubscribe: any;

  allTypesStatusData: any = {};
  workflowTasks: any;
  selectedTaskDay: any = {};
  clearDaysFilter = true;
  taskTableColumns: any;
  priorities: Array<any> = [{id: 'High', name: 'High', badge: 'H', colorCode: '#f1645a'}, {
    id: 'Medium',
    name: 'Medium',
    badge: 'M',
    colorCode: 'colorCode'
  }, {id: 'Low', name: 'Low', badge: 'L', colorCode: 'colorCode'}];
  tasksData: Array<any> = [];
  searchData: any = {
    searchKey: '',
    advSearchObj: {}
  };
  channelType: string;
  channelId: string;
  reveal: any = {
    timer: false,
    cal_event: false,
    flag: false,
    checklist: false,
    workProjection: false,
    taskCreation: false
  };
  flagValue = '';
  flagName: any;
  bulkDueDate: any;
  bulkstatusId: any;
  bulkPriorityId: any;
  bulkAssigneeId: any;
  isClientDashboard = false;

  @Input() set channelData(id) {
    this.filterObj.company = id;
    this.filterObj.assignees = '';
    this.filterObj.date = 'All';
    this.isClientDashboard = true;
  }

  selectedTableRows: Array<any> = [];
  selectedRowsClients = false;
  selectedRowsId: Array<any> = [];
  actions: Array<any> = [];
  @ViewChild('tasksTable') tasksTable;
  invoiceCompanyId: any;
  invoiceClientId: any;
  invoiceTitle: any;
  selectedRowsStatus = false;
  statusTypes: Array<any> = [];

  timeZone: string = '(' + moment.tz(moment.tz.guess()).format('z') + ') ' + moment.tz.guess();
  @Input() isClientInfo;
  revealWidth = '40%';
  filters: Array<any> = [];
  tasksStatus: Array<any> = [
    {id: 'Assigned', name: 'Assigned'},
    {id: 'Blocked', name: 'Blocked'},
    {id: 'In Progress', name: 'In Progress'},
    {id: 'Review', name: 'Review'},
    {id: 'Done', name: 'Done'},
  ];
  currentEnvironment: any;
  clientPlans: any;
  planStrategies: any;
  taskGoalDate: any;
  selectedPlanStrategy: any;
  selectedPlan: any;
  selectedClient: any;
  taskCreationError: any;
  constructor(private _fb: FormBuilder, private _route: ActivatedRoute, private _router: Router, private toastService: ToastService, private loadingService: LoadingService,
              private dateFormater: DateFormater, private stateService: StateService, private titleService: PageTitleService,
              private tasksService: TasksService, private switchBoard: SwitchBoard, private reportService: ExportService, private changeDetectorRef: ChangeDetectorRef,
              private loginService: LoginService, private taxPlanningService: TaxPlanningService) {
  }

  ngOnInit() {
    // Defer multiselect rendering by one tick so the navigation click that created
    // this component has fully propagated before ClickOutsideDirective registers
    // its document:click listener — prevents _settings undefined crash in closeDropdown().
    setTimeout(() => { this.multiselectReady = true; }, 0);
    const base = this;
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.currentEnvironment = environment;
    this.timeZone = Session.getUser().timeZone;
    this.updateActions();
    this.channelType = 'clients';
    this.serviceDateformat = this.dateFormater.getServiceDateformat();
    this.dateFormat = 'MM-DD-YYYY';
    if (!this.isClientDashboard) {
      this.titleService.setPageTitle('Tasks');
    }
    this.users = Session.getUsers() || [];
    if (this.users && this.users.length == 0) {
      this.getDefaultCompanyUsers();
    } else {
      this.formatUsersData();
    }

    if (this.isClientInfo) {
      this.taskDisplay = 'list';
    }
    this.routeSub = this._route.params.subscribe(params => {
      const base = this;
      this.taskId = params.taskId;
    });


    const state = this.stateService.getPrevState();
    if (state && state.data && state.data.filters) {
      this.filters = state.data.filters;
    }
    if (state && state.key == 'wall-task-Tracker') {
      const item = state;
      if (item) {
        this.orgTypes = item.data.orgTypes;
        this.allTypesStatusData = item.data.allTypesStatusData;
        this.clientCompaniesList = item.data.clientCompanies;
        this.contactsList = item.data.contactsList;
        this.filterObj = item.data.filterObj;
        this.searchData = {
          searchKey: item.data.filterObj.searchKey || '',
          advSearchObj: item.data.filterObj.advSearchObj || {}
        };
        this.selectedCompanies = item.data.companies;
        this.selectedAssignees = item.data.assignee;
        this.selectedStatuses = item.data.statuses;
        this.showListView = item.data.showListView;
        this.setFilterData(item);
        this.listView(true);
      }
      this.stateService.pop();
    } else {
      this.getClientsList();
    }
    this.allTasksLoaded = false;

    this.switchBoard.onPageChangeListener.next({
      url: this._route.url,
      name: 'Task Dashboard',
      id: 'TASKS'
    });

    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });

    this.switchBoard.onToggleFeedback.next({
      display: true,
      pageName: 'Tasks page'
    });

    this.onTaskCreateSubscribe = this.switchBoard.onTaskCreated.subscribe(task => {
      this.onTaskCreated();
    });

    this.onClearFilter = this.switchBoard.onClearMenuFilter.subscribe(click => {
      this.searchData.searchKey = '';
      this.searchData.advSearchObj = {};
      if (this.isClientInfo) {
        this.taskDisplay = 'list';
        this.filterObj.display = 'list';
      }
      if (click !== 'tasksSearch') {
        this.clearFilter();
      }
      this.listView(true);
    });

    this.onTaskEditSubscribe = this.switchBoard.onEditedTask.subscribe(task => {
      this.onTaskEdited(task);
    });

    this.switchBoard.onTasksSearch.pipe<any>(takeUntil<any>(this.destroy$)).subscribe(search => {
      this.searchInTasks(search);
    });

    this.switchBoard.onTasksAdvSearch.pipe(takeUntil(this.destroy$)).subscribe(search => {
      if (search.filters) {
        this.filters = search.filters;
      }
      if (search.searchObj) {
        this.advSearchInTasks(search.searchObj);
      } else {
        this.advSearchInTasks(search);
      }
    });

    this.switchBoard.onToastConfirm
      .pipe(takeUntil(this.destroy$))
      .subscribe(toast => {
        this.deleteTask(toast.data);
      });

    // this.switchBoard.invoiceActionsDone.pipe(takeUntil(this.destroy$)).subscribe(next => {
    //   this.resetSelectedCheckBoxes();
    // });
    //
    // this.switchBoard.onRevealClose.pipe(takeUntil(this.destroy$)).subscribe(next => {
    //   this.hideReveal(next);
    // });
    //
    // this.switchBoard.onRefreshTrackerPage
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(next => {
    //     this.listView(true);
    //   });
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  formatUsersData() {
    if (this.users && this.users.length > 0){
      _.each(this.users, function(user){
        user['name'] = user.firstName + ' ' + user.lastName;
        user['email'] = user.id;
      });
    }
  }

  searchInTasks(search) {
    let searchObj = {};
    if (search.searchText) {
      searchObj = {
        searchKey: search.searchText,
        advSearchObj: {}
      };
      this.searchData = searchObj;
    }
    this.searchData = searchObj;
    this.nextIndex = 0;
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.loadData();
    }
  }

  advSearchInTasks(search) {
    let searchObj = {};
    searchObj = this.checkSearch(search);
    this.searchData = searchObj;
    this.nextIndex = 0;
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.loadData();
    }
  }

  checkSearch(request) {
    const base = this;
    let searchData = _.cloneDeep(request);
    if (request.searchText || !_.isEmpty(request.advSearchObj)) {
      request.searchKey = request.searchText;
      request.advSearchObj = {};
    } else {
      request.searchKey = '';
      request.advSearchObj = {};
    }
    return request;
  }

  editCompanyName($event) {
    this.editingCompany = !this.editingCompany;
  }

  showNext($event) {
    $event && $event.preventDefault();
    this.recurringState = true;
  }

  showPrevious($event) {
    $event && $event.preventDefault();
    this.recurringState = false;
  }


  getClientsList() {
    const obj = {
      fromIndex: -1
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClients(this.org, this.user, obj)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.clientCompaniesList = this.formatClientsData(response.clients);
        this.clearFilter();
         this.filterObj.column = 'customerName';
         this.filterObj.order = 'asc';
        this.listView(true);
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get clients list');
      });
  }

  formatClientsData(clients) {
    let data = [];
    if (clients && clients.length > 0) {
      _.each(clients, function(client) {
        let obj = {};
        obj['id'] = client.id;
        obj['name'] = client.firstName + ' ' + client.lastName;
        obj['qountClientId'] = client.qountClientId;
        data.push(obj);
      });
    }
    return data;
  }

  clearFilter() {
    const base = this;
    this.selectedTaskDay = _.find(this.tasksDays, {id: 'Snapshot'});
    base.selectedAssignees = [{
      email: Session.get('user').id,
      name: Session.get('user').first_name + ' ' + Session.get('user').last_name
    }];
    base.selectedAssignee = [Session.get('user').id];
    base.filterObj.assignees = base.selectedAssignee;
    base.filterObj.date = 'Snapshot';

    this.selectedStatuses = _.map(base.tasksStatus, 'id');
    this.filterObj.status = this.selectedStatuses;

    base.filterObj.type = '';
    base.filterObj.order = '';
    base.filterObj.column = '';
    base.filterObj.toDate = '';
    base.filterObj.fromDate = '';
    base.clearDaysFilter = false;
    setTimeout(function() {
      base.clearDaysFilter = true;
    });

    if (this.isClientInfo) {
      this.selectedTaskDay = _.find(this.tasksDays, {id: 'All'});
      base.selectedAssignee = [];
      base.selectedAssignees = [];
      this.filterObj.date = 'All';
      this.filterObj.assignees = '';
      this.isClientDashboard = true;
    }
  }

  setFilterData(item) {
    const base = this;
    if (item.data.filterObj.date) {
      const date = _.find(this.tasksDays, {id: item.data.filterObj.date});
      if (date.id == 'Snapshot') {
        this.isShowAll = true;
      } else {
        this.isShowAll = false;
        this.badgeText = date.id == 'Today' ? 'Due Today' : date.id;
      }
      setTimeout(function() {
        base.selectedTaskDay = date || {};
      });
    }
  }

  onTaskCreated() {
    this.listView(true);
    this.setDefaultFilter();
  }

  setCompaniesToSearch(type) {
    if (type == 'Biz Taxes') {
      this.companiesToSearch = this.groupedCompanies['Biz Taxes'];
    } else if (type == 'Ind Taxes') {
      this.companiesToSearch = this.groupedCompanies['Ind Taxes'];
    } else {
      this.companiesToSearch = this.groupedCompanies.Books;
    }
  }

  loadData() {
    const base = this;
    this.filterObj['typeId'] = [];
    this.loadingService.triggerLoadingEvent(true);
    this.taskIndex = 0;
    if (this.filterObj && this.filterObj.fromDate) {
      this.filterObj.fromDate = this.filterObj.fromDate ? this.dateFormater.formatDate(this.filterObj.fromDate, this.dateFormat, this.serviceDateformat) : '';
    }
    if (this.filterObj && this.filterObj.toDate) {
      this.filterObj.toDate = this.filterObj.toDate ? this.dateFormater.formatDate(this.filterObj.toDate, this.dateFormat, this.serviceDateformat) : '';
    }
    if (this.searchData.searchKey || !_.isEmpty(this.searchData.advSearchObj)) {
      this.filterObj.searchKey = this.searchData.searchKey;
      this.filterObj.advSearchObj = this.searchData.advSearchObj;
    } else {
      this.filterObj.searchKey = '';
      this.filterObj.advSearchObj = {};
    }
    if (this.filterObj.type.length > 0) {
      _.forEach(this.filterObj.type, (pref) => {
        const findworkflow = _.find(base.orgTypes, {id: pref});
        if (findworkflow) {
          base.filterObj.typeId.push(findworkflow.workflowId);
        }
      });
    }
    if (this.filterObj.type.length == 0 && this.filterObj.company == '' && this.filterObj.assignees.length == 0) {
      this.oldFilterObj = _.cloneDeep(this.filterObj);
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, 'One of Workflow, Client, Contacts or Assigned must be selected');
    } else {
      this.tasksService.clientTasksByPost(this.filterObj, this.taskIndex, this.filterObj.company || [])
        .subscribe(tasks => {
          delete base.filterObj.typeId;
          this.oldFilterObj = _.cloneDeep(this.filterObj);
          this.data = tasks;
          this.taskIndex = this.taskIndex + 15;
          this.setData();
          this.allTasksLoaded = false;
          this.tasksLoading = false;
          this.loadingService.triggerLoadingEvent(false);
        }, error => {
          delete base.filterObj.typeId;
          this.loadingService.triggerLoadingEvent(false);
        });
    }
  }

  getDefaultCompanyUsers() {
    this.tasksService.getAssignees().subscribe(response => {
      this.users = response.users;
      _.forEach(this.users, function(user) {
        user.name = user.firstName + ' ' + user.lastName;
        user.email = user.id;
      });
      Session.setUsers(this.users);
    }, error => {
    });
  }

  ngOnDestroy() {
    if (this.routeSubscribe) {
      this.routeSubscribe.unsubscribe();
    }
    if (this.onTaskCreateSubscribe) {
      this.onTaskCreateSubscribe.unsubscribe();
    }
    if (this.onClearFilter) {
      this.onClearFilter.unsubscribe();
    }
    if (this.onTaskEditSubscribe) {
      this.onTaskEditSubscribe.unsubscribe();
    }
    if (this.onTaskSearchSubscribe) {
      this.onTaskSearchSubscribe.unsubscribe();
    }
    if (this.clearSub) {
      this.clearSub.unsubscribe();
    }
    if (this.onNewCompanySubscribe) {
      this.onNewCompanySubscribe.unsubscribe();
    }
    if (jQuery('#company-dropdown .filter-textbox input')) {
      jQuery('#company-dropdown .filter-textbox input').remove();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleDisplay() {
    this.showGridView = true;
    this.showListView = false;
    this.filterObj = this.oldFilterObj;
    this.filterObj.display = 'grid';
    this.filterObj.order = '';
    this.filterObj.column = '';
    if (this.filterObj.date == '--None--' || this.filterObj.date == '') {
      this.badgeText = 'Blank';
      this.isShowAll = false;
    } else if (this.filterObj.date == 'Snapshot') {
      this.isShowAll = true;
    } else {
      this.isShowAll = false;
      this.badgeText = this.filterObj.date == 'Today' ? 'Due Today' : this.filterObj.date;
    }
    this.loadData();
  }

  setData() {
    const base = this;
    if (this.isShowAll) {
      this.pastDue = this.data.PastDue || [];
      _.each(this.pastDue, function(task) {
        base.updateTaskValues(task);
      });
      this.dueToday = this.data.today || [];
      _.each(this.dueToday, function(task) {
        base.updateTaskValues(task);
      });
      this.next60Days = this.data.Next60Days || [];
      _.each(this.next60Days, function(task) {
        base.updateTaskValues(task);
      });
      this.pastDueCount = this.data.PastDuecount;
      this.next60DaysCount = this.data.Next60Dayscount;
      this.dueTodayCount = this.data.Todaycount;
      this.totalCount = this.pastDueCount + this.next60DaysCount + this.dueTodayCount;
      this.showNoRecords = false;
      this.allTasksList = this.pastDue.concat(this.dueToday).concat(this.next60Days);
    } else {
      this.taskIndex = 0;
      this.workflowTasks = this.data.totalTasks || [];
      for (let i = 0; i < this.workflowTasks.length; i++) {
        _.each(this.workflowTasks[i].tasks, function(task) {
          base.updateTaskValues(task);
        });
      }
      this.taskIndex += this.data.count;
      this.showNoRecords = false;
    }
  }

  updateTaskValues(task) {
    const base = this;
    task.displayName = base.setTitleString(task);
    task.displayDescription = base.setDetailsString(task);
    task.statusColor = base.getStatusColor(task);
    task.priorityColor = base.getPriorityColor(task);
    task.bgColor = base.getBackgroundColor(task);
    task.dayOfMonth = base.getDayOfTheMonth(task.dueDate);
    task.monthName = base.getMonthName(task.dueDate);
    task.clockColor = base.getClockColor(task);
  }

  getCustomerName(companyId) {
    const company = _.find(this.companiesList, {id: companyId});
    return company ? company.name : '';
  }

  getAssigneeName(taskAssignees) {
    const user = taskAssignees[0];
    if (taskAssignees.length > 1) {
      return user ? user.firstName + ' ' + user.lastName + ',' + (taskAssignees.length - 1) + 'Others' : '';
    } else {
      return user ? user.firstName + ' ' + user.lastName : '';
    }
  }

  markDone(task, state) {
    this.updateObjState = state;
    this.loadingService.triggerLoadingEvent(true);
    this.tasksService.patchTaskStatus(task.id, 'Done', {}).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      task.status = 'Done';
      this.updateTaskData(task);
      this.toastService.pop(TOAST_TYPE.success, 'Status moved to Done');
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Status');
    });
  }

  getMonthName(date) {
    if (date) {
      const momentObj = moment(date, 'MM/DD/YYYY');
      return momentObj.format('MMM');
    }
    return '';
  }

  getDayOfTheMonth(date) {
    if (date) {
      const momentObj = moment(date, 'MM/DD/YYYY');
      return momentObj.format('DD');
    }
    return '';
  }

  isDuplicate(user) {
    const base = this;
    let isDuplicateValue = true;
    _.forEach(this.selectedValues, function(data) {
      if (data.email != user.email) {
        isDuplicateValue = false;
      }
    });
    return isDuplicateValue;
  }

  removeSelectedValue(index) {
    this.selectedValues.splice(index, 1);
    if (this.selectedValues.length == 0) {

    }
  }

  updateTaskData(data) {
    const base = this;
    if (this.updateObjState == 'pastdue') {
      const taskIndex = _.findIndex(this.pastDue, {id: data.id});
      if (taskIndex != -1) {
        base.updateTaskValues(data);
        this.pastDue[taskIndex] = data;
      }
    }
    if (this.updateObjState == 'duetoday') {
      const taskIndex = _.findIndex(this.dueToday, {id: data.id});
      if (taskIndex != -1) {
        base.updateTaskValues(data);
        this.dueToday[taskIndex] = data;
      }
    }
    if (this.updateObjState == 'next60days') {
      const taskIndex = _.findIndex(this.next60Days, {id: data.id});
      if (taskIndex != -1) {
        base.updateTaskValues(data);
        this.next60Days[taskIndex] = data;
      }
    }
  }

  moveNextStatusInGrid(task, state) {
    this.tasksService.updateTaskStatusOrder(this.org, this.user, task.id, 'grid', task).subscribe(response => {
      this.updateObjState = state;
      this.updateTaskData(response);
      this.toastService.pop(TOAST_TYPE.success, `Status Updated Successfully`);
    }, error => {

      const message = error.message ? error.message : `Failed To Update Status`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });
  }

  onDateFilterSelect(taskDay) {
    this.resetSelectedCheckBoxes();
    if (this.filterObj.date != (taskDay && taskDay.id)) {
      if (taskDay && taskDay.id) {
        this.filterObj.date = taskDay.id;
        this.filterObj.order = '';
        this.filterObj.column = '';
        this.filterObj.fromDate = '';
        this.filterObj.toDate = '';
        if (taskDay.id == 'Snapshot') {
          this.isShowAll = true;
        } else {
          this.isShowAll = false;
          this.badgeText = taskDay.id == 'Today' ? 'Due Today' : taskDay.id;
        }
        if (taskDay.id != 'Custom') {
          if (this.filterObj.display == 'list') {
            this.listView(true);
          } else {
            this.loadData();
          }
        }
      } else if (taskDay.id != 'Custom' && this.filterObj.date != (taskDay && taskDay.id == '--None--')) {
        this.filterObj.date = '';
        this.filterObj.order = '';
        this.filterObj.column = '';
        this.filterObj.fromDate = '';
        this.filterObj.toDate = '';
        this.badgeText = 'Blank';
        this.isShowAll = false;
        if (this.filterObj.display == 'list') {
          this.listView(true);
        } else {
          this.loadData();
        }
      }
    }
  }

  setFromDate($event) {
    if (!_.isEmpty($event)) {
      this.filterObj.fromDate = $event;
      if (this.filterObj.date === 'Custom' && this.filterObj.fromDate && this.filterObj.toDate) {
        if (this.filterObj.display == 'list') {
          this.listView(true);
        } else {
          this.loadData();
        }
      }
    } else {
      this.filterObj.fromDate = '';
    }
  }

  setToDate($event) {
    if (!_.isEmpty($event)) {
      this.filterObj.toDate = $event;
      if (this.filterObj.date === 'Custom' && this.filterObj.fromDate && this.filterObj.toDate) {
        if (this.filterObj.display == 'list') {
          this.listView(true);
        } else {
          this.loadData();
        }
      }
    } else {
      this.filterObj.toDate = '';
    }
  }

  onStatusFilterSelect(status: any, check) {
    const base = this;
    this.resetSelectedCheckBoxes();
    if (check) {
      this.selectedStatus.push(status.id);
      this.filterObj.status = this.selectedStatus;
    } else {
      this.filterObj.status = _.without(this.selectedStatus, status.id);
      this.selectedStatus = this.filterObj.status;
    }
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.loadData();
    }
  }

  onAllStatusFilterSelect(statuses: any, check) {
    this.resetSelectedCheckBoxes();
    if (check) {
      this.selectedStatus = _.map(statuses, 'id');
      this.filterObj.status = this.selectedStatus;
    } else {
      this.filterObj.status = [];
      this.selectedStatus = [];
    }
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.loadData();
    }
  }

  onCompanyFilterSelect(customer: any, check) {
    this.resetSelectedCheckBoxes();
    const obj = _.find(this.clientCompaniesList, {name: customer.name});
    if (check) {
      this.selectedCompany.push(obj.qountClientId);
      this.filterObj.company = this.selectedCompany;
    } else {
      this.filterObj.company = _.without(this.selectedCompany, obj.qountClientId);
      this.selectedCompany = this.filterObj.company;
    }
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.loadData();
    }
  }

  onAllCompaniesFilterSelect(customers: any, check) {
    this.resetSelectedCheckBoxes();
    if (check) {
      let clientsList = [];
      _.each(this.clientCompaniesList, (client) => {
        if (client.qountClientId) {
          clientsList.push(client.qountClientId);
        }
      });
      this.selectedCompany = clientsList;
      this.filterObj.company = this.selectedCompany;
    } else {
      this.filterObj.company = [];
      this.selectedCompany = [];
    }
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.loadData();
    }
  }

  onAssigneeFilterSelect(assignee: any, check) {
    this.resetSelectedCheckBoxes();
    if (check) {
      this.selectedAssignee.push(assignee.email);
      this.filterObj.assignees = this.selectedAssignee;
      this.assignedName.push(assignee.name);
      this.isAssigneeSelect = true;
    } else {
      this.filterObj.assignees = _.without(this.selectedAssignee, assignee.email);
      this.selectedAssignee = this.filterObj.assignees;
      this.assignedName = _.without(this.assignedName, assignee.name);
      if (this.assignedName.length > 0) {
        this.isAssigneeSelect = true;
      } else {
        this.isAssigneeSelect = false;
      }
    }
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.loadData();
    }
    this.assigneeName = this.assignedName + '\'s Tasks';
  }

  onAllAssigneesFilterSelect(assignees: any, check) {
    this.resetSelectedCheckBoxes();
    if (check) {
      this.selectedAssignee = _.map(assignees, 'email');
      this.filterObj.assignees = this.selectedAssignee;
    } else {
      this.filterObj.assignees = [];
      this.selectedAssignee = [];
    }
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.loadData();
    }
  }

  setDefaultFilter() {
    const base = this;
    if (this.filterObj.date == 'Snapshot') {
      this.selectedTaskDay = _.find(this.tasksDays, {id: 'Snapshot'});
    } else {
      this.selectedTaskDay = _.find(this.tasksDays, {id: base.filterObj.date});
    }
  }

  getStatusColor(status) {
    let color = '#878787';
    switch (status) {
      case 'Assigned':
        color = '#3A618E';
        break;
      case 'In Progress':
        color = '#00B1AA';
        break;
      case 'Done':
        color = '#00B3AC';
        break;
      case 'Blocked':
        color = '#D00707';
    }
    return color;

  }

  getPriorityColor(status) {
    let color = '#04B2AB';
    switch (status) {
      case 'High':
        color = '#AA4540';
        break;
      case 'Low':
        color = '#24B574';
        break;
      case 'Medium':
        color = '#04B2AB';
        break;
      case 'Blocked':
        color = '#67211E';
    }
    return color;

  }

  navigateToPost(task) {
    this.channelId = task.clientId || '';
    let link = ['clients', task.clientId, 'posts', task.postId];
    this.switchBoard.onDisplayFloatingWindow.next({
      url: link,
      title: `${task.popupTitle}`,
      initialView: 'maximized',
      maxmizeStyle: {
        height: '90vh',
        width: '90vw'
      }
    });
  }

  checkClientView(task) {
    this.channelId = task.clientId || '';
  }


  navigateToTracker(task) {
    this.checkClientView(task);
    this.addWallState('wall-task-Tracker');
    this._router.navigate([this.channelType, this.channelId, 'task', task.id, 'singlePage']);
  }

  addWallState(state) {
    const data: any = {
      filterObj: this.filterObj,
      companies: this.selectedCompanies,
      assignee: this.selectedAssignees,
      statuses: this.selectedStatuses,
      showListView: this.showListView,
      orgTypes: this.orgTypes,
      allTypesStatusData: this.allTypesStatusData,
      clientCompanies: this.clientCompaniesList,
    };
    data.filters = this.filters;
    if (state == 'wall-task-Tracker') {
      if (this.isClientInfo) {
        this.stateService.addState(new State('channel-tasks', this._router.url, data, null));
      } else {
        this.stateService.addState(new State('wall-task-Tracker', this._router.url, data, null));
      }
    } else if (state == 'wall-tasks') {
      this.stateService.addState(new State('wall-tasks', this._router.url, data, null));
    } else if (state == 'TASK_COMP_SELECTED') {
      this.stateService.addState(new State('TASK_COMP_SELECTED', this._router.url, data, null));
    }
  }

  setDetailsString(task) {
    if (task && task.description && task.postId && task.description.length > 150) {
      return task.description.substring(0, 155) + '......';
    } else if (task.description && !task.postId && task.description.length > 40) {
      return task.description.substring(0, 48) + ' ......';
    } else {
      return task.description;
    }
  }

  setTitleString(task) {
    if (task && task.name && task.name.length > 35) {
      return task.name.substring(0, 35) + '....';
    } else {
      return task.name;
    }
  }

  setTableProjectString(task) {
    if (task && task.name && task.name.length > 25) {
      return task.name.substring(0, 25) + '....';
    } else {
      return task.name;
    }
  }

  setStringSizeLimit(name) {
    if (name && name.length > 25) {
      return name.substring(0, 25) + '....';
    } else {
      return name;
    }
  }

  getBackgroundColor(task) {
    const user = task.taskAssignees[0];
    if (user) {
      return user.colorCode;
    }
    return '#00B1AC';
  }

  getClockColor(task) {
    if (task.status != 'Blocked') {
      return '#00B1AC';
    }
    return '#f1645a';
  }

  isPastDue(task) {
    if (task && task.pastDue) {
      return '#f1645a';
    } else {
      return '#818DC6';
    }
  }

  getTableAssigneeToolTipName(assignees) {
    if (assignees) {
      const firstletter = assignees.name ? assignees.name : '';
      return firstletter;
    }
    return '';
  }

  getPriorityToolTipName(prior) {
    if (prior) {
      const firstletter = prior ? prior : '';
      return firstletter;
    }
    return '';
  }

  getTableAssigneeBadge(assignee) {
    if (assignee) {
      const firstlettr = assignee.firstName ? assignee.firstName.charAt(0) : '';
      const lastletter = assignee.lastName ? assignee.lastName.charAt(0) : '';
      return firstlettr + lastletter;
    }
    return '';
  }

  getTableBackgroundColor(taskassignee) {
    if (taskassignee) {
      return taskassignee.colorCode;
    }
    return '#00B1AC';
  }

  getPriorityBadge(priority) {
    if (priority) {
      return _.find(this.priorities, {name: priority});
    }
    return false;
  }

  /*
    getStatus(status, type) {
      if (status) {
        const statuses = this.allTypesStatusData[type] ?
          this.allTypesStatusData[type].typeStatus ? this.allTypesStatusData[type].typeStatus : [] : [];
        const current = _.find(statuses, {id: status});
        if (current) {
          current.name = current.status;
          return current;
        } else {
          return false;
        }
      }
      return false;
    }
  */

  isPostlastActivity(task) {
    if (task.postlastActivity) {
      return '#808080';
    }
    return '#4554A4';
  }

  buildTasksTableData(data, refreshTable?) {
    const base = this;
    this.tasksTableData.options = {
      height: '70vh',
      selectorString: 'id',
      showSearch: false
    };
    this.tasksTableData.columns = base.formatColumnsForTable(this.taskTableColumns);
    this.tasksTableData.columns.push({
      name: 'actions',
      classes: 'pointer zero-overflow',
      title: '',
      type: 'html',
      sortable: false
    });

    if (refreshTable) {
      this.tasksTableData.rows = [];
    } else {
      this.tasksTableData.rows = this.tasksTableData.rows || [];
    }
    const rows = base.tasksTableData.rows || [];
    data.forEach(function(task) {
      const row = base.createTableRow(task);
      rows.push(row);
    });
    this.tasksTableData = {...this.tasksTableData, rows};
    this.handleSortOrder(this.tasksSort, this.tasksTableData.columns);
    if (refreshTable) {
      this.hasTasks = false;
    }
    setTimeout(function() {
      base.hasTasks = true;
    });
    this.loadingService.triggerLoadingEvent(false);
  }

  createTableRow(task) {
    const base = this;
    const row: any = {};
    row.selectCol = `<input type='checkbox' class='checkbox'/>`;
    const tooltipClass = base.getTooltipHtmlClass();
    const titletipClass = base.getTitleTooltipHtmlClass();

    _.each(Object.keys(task), function(key) {
      if (key == 'customerName') {
        row.popupTitle = task[key];
        row[key] = `<a class='actionOnId' data-action='edit'><span class='icon'>${base.setStringSizeLimit(task[key])}</span></a>`;
        // row[key] = `<a class='actionOnId' data-action='edit'><span class='icon badge-tooltip'>${base.setStringSizeLimit(task[key])}<span class='${tooltipClass} clientTooltip'>${task.toolTipData}</span></span></a>`;
      } else if (key == 'name') {
        row[key] = `<span class='icon badge-tooltip pointer'>${base.setTableProjectString(task)}<span style="max-width: 330px !important;min-width: 300px !important;white-space: pre-wrap !important;font-size: 14px" class='${titletipClass} clientTooltip'>${task[key]}</span></span>`;
        row.title = task[key];
      } else if (key == 'priority') {
        row[key] = base.getPriorityBadge(task[key]);
      } else if (key == 'status') {
        const obj = _.find(base.tasksStatus, {id: task[key]});
        if (obj) {
          row[key] = obj;
        } else {
          row[key] = {id: task[key], name: task[key]};
        }
      } else if (key == 'taskAssignees') {
        if (task[key] && task[key].length > 0) {
          let data = [];
          _.each(task[key], function(user){
            let obj = _.find(base.users, {id: user.assignedTo});
            if (obj) {
              obj['assignedTo'] = obj.id;
              obj['badge'] = obj.firstName.charAt(0) + obj.lastName.charAt(0);
              data.push(obj);
            }
          });
          row[key] = _.uniqBy(data, 'assignedTo');
        }
      } else {
        row[key] = task[key];
      }
    });
    row.actions = `<a class='action' data-action='edit-task'><span class='badge-tooltip'><i class="material-icons task-edit-icon">mode_edit</i><span class='bottomTooltiptext taskActionsTooltip' style="top: 125% !important;">Edit Task</span></span></a>`;
    row.actions += '<a class=\'action\' data-action=\'delete-task\'><i class=\'icon ion-trash-b\'></i></a>';

    row.companyName = row.companyName ? row.companyName : '';
    row.dueDate = row.dueDate ? row.dueDate : '';
    row.taskAssignees = row.taskAssignees ? row.taskAssignees : '';
    row.actions = row.actions ? row.actions : '';
    row.isEditable = false;
    return row;
  }

  getTooltipHtmlClass() {
    return this.tasksTableData.rows && this.tasksTableData.rows.length == 0 ? 'bottomTooltiptext' : 'topTooltiptext';
  }

  getTitleTooltipHtmlClass() {
    return this.tasksTableData.rows && this.tasksTableData.rows.length == 0 ? 'bottomTooltiptext taskBottomTitleTooltip' : 'topTooltiptext taskTopTitleTooltip';
  }

  formatColumnsForTable(data) {
    const base = this;
    const colsArray = [];
    let orderArray;
    if (typeof data !== 'string') {
      orderArray = data;
    } else {
      orderArray = JSON.parse(data);
    }
    _.each(Object.keys(orderArray), function(key) {
      if (key === 'Client') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          type: 'html',
          classes: 'pointer',
          sortable: true
        });
      } else if (key === 'Title') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          type: 'html',
          classes: 'pointer',
          sortable: true
        });
      } else if (key === 'Status') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          classes: 'pointer input-search',
          type: 'badge-input-search',
          'status-col': true,
          editable: true,
          displayName: 'name',
          full_name: 'name',
          background: 'colorCode',
          'multi-dropdown': false,
          data: base.tasksStatus,
          placeholder: key,
          sortable: true,
          moveStatus: true
        });
      } else if (key === 'Due Date') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          type: 'date',
          format: 'MM/DD/YYYY',
          placeholder: 'MM/DD/YYYY',
          classes: 'input-date pointer',
          sortable: true
        });
      } else if (key === 'Assigned To') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          type: 'badge-input-search',
          displayName: 'badge',
          full_name: 'name',
          background: 'colorCode',
          'multi-dropdown': true,
          data: base.users,
          placeholder: key,
          classes: 'input-search pointer',
          sortable: true
        });
      } else if (key === 'Priority') {
        colsArray.push({
          name: orderArray[key],
          title: key,
          type: 'badge-input-search',
          displayName: 'badge',
          full_name: 'name',
          background: 'colorCode',
          'multi-dropdown': false,
          data: base.priorities,
          placeholder: key,
          classes: 'input-search pointer',
          sortable: true
        });
      } else if (key !== 'Aging'){
        colsArray.push({name: orderArray[key], title: key, type: 'normal', sortable: true});
      }
    });
    return colsArray;
  }

  handleTasksTableAction($event) {
    const action = $event.action;
    if (action == 'edit') {
      this.navigateToTracker($event);
    } else if (action == 'edit-task') {
      this.navigateToTracker($event);
    } else if (action == 'delete-task') {
      this.removeTask($event);
    } else if (action == 'collaboration') {
      this.navigateToPost($event);
    }
  }

  removeTask($event) {
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', $event);
  }

  deleteTask(task) {
    this.loadingService.triggerLoadingEvent(true);
    this.tasksService.deleteTask(this.org, this.user, task.id)
      .subscribe(success => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Task Deleted Successfully');
        this.hasTasks = false;
        this.listView();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Delete Task');
      });
  }

  optionSelected($event) {
    const data = _.find(this.tasksData, {id: $event.row.id});
    if ($event.column == 'status' || $event.column == 'priority') {
      data[$event.column] = $event.entry.name;
    } else {
      if ($event.column && !$event.multiDropdown) {
        data[$event.column] = $event.entry;
      } else if ($event.column && $event.multiDropdown && $event.type == 'add') {
        data[$event.column] = [...data[$event.column], $event.entry];
      } else if ($event.column && $event.multiDropdown && $event.type == 'remove') {
        let entries = data[$event.column] || [];
        const index = _.findIndex(entries, {id: $event.entry.id});
        const assignedToIndex = _.findIndex(entries, {assignedTo: $event.entry.assignedTo});
        if (index !== -1) {
          entries = entries.filter((entry, idx) => {
            return index != idx;
          });
        } else if (assignedToIndex !== -1) {
          entries = entries.filter((entry, idx) => {
            return assignedToIndex != idx;
          });
        }
        data[$event.column] = entries;
      }
    }
    data.taskAssignees = this.getTpTaskAssignees(data.taskAssignees);
    this.tasksService.updateTaskRow(data)
      .subscribe(response => {
        const index = _.findIndex(this.tasksTableData.rows, {id: $event.row.id});
        if (index !== -1) {
          const rows = this.tasksTableData.rows || [];
          rows[index] = this.createTableRow(response);
          this.tasksTableData = {...this.tasksTableData, rows};
          this.tasksData[index] = response;
        }
        this.toastService.pop(TOAST_TYPE.success, $event.column.charAt(0).toUpperCase() + $event.column.slice(1) + ' ' + 'Updated Successfully');
      }, error => {
        try {

          const message = error.message || `Failed To Update ${$event.column.charAt(0).toUpperCase()} ${$event.column.slice(1)}`;
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (error) {
          const message = `Failed To Update ${$event.column.charAt(0).toUpperCase()} ${$event.column.slice(1)}`;
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  getTpTaskAssignees(asignees) {
    let data = [];
    if (asignees && asignees.length > 0) {
      _.each(asignees, function(item) {
        if (!item['assignedTo']){
          item['assignedTo'] = item.id;
        }
      });
      data = _.uniqBy(asignees, 'assignedTo');
    }
    return data;
  }

  updateInput(obj) {
    const task = _.find(this.tasksData, {id: obj.row.id});
    if (task) {
      task[obj.column] = obj.row[obj.column];
      task.taskAssignees = this.getTpTaskAssignees(task.taskAssignees);
      this.tasksService.updateTaskRow(task)
        .subscribe(response => {
          const index = _.findIndex(this.tasksTableData.rows, {id: obj.row.id});
          if (index !== -1) {
            this.tasksTableData.rows[index] = this.createTableRow(response);
          }
          this.toastService.pop(TOAST_TYPE.success, 'Task Updated Successfully');
        }, error => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Task');
        });
    }
  }

  closeEditTaskDialog() {
    this.viewEditTask = false;
  }

  handleSortOrder(tasksSortOrder, columns) {
    _.each(columns, function(column) {
      column.sortType = tasksSortOrder[column.name];
    });
  }

  sortByColumn(obj) {
    this.filterObj.column = obj.column;
    this.filterObj.order = obj.order;
    this.taskIndex = 0;
    this.sortTasks(obj);
  }

  sortTasks(obj) {
    const base = this;
    this.filterObj['typeId'] = [];
    this.tasksSort[obj.column] = obj.order;
    this.resetSortOrder(this.tasksSort, this.tasksTableData.columns, obj.column);
    this.loadingService.triggerLoadingEvent(true);
    if (this.filterObj.type.length > 0) {
      _.forEach(this.filterObj.type, (pref) => {
        const findworkflow = _.find(base.orgTypes, {id: pref});
        if (findworkflow) {
          base.filterObj.typeId.push(findworkflow.workflowId);
        }
      });
    }
    this.tasksService.clientTasksByPost(this.filterObj, this.taskIndex, this.filterObj.company || [])
      .subscribe(response => {
        delete base.filterObj.typeId;
        if (response.tasksList.length == 0) {
          this.hasNextSet = false;
          this.loadingService.triggerLoadingEvent(true);
        } else {
          this.hasNextSet = true;
          this.tasksTableData.rows = [];
          this.taskIndex += response.tasksList.length;
          this.loadingService.triggerLoadingEvent(false);
          this.buildTasksTableData(response.tasksList, true);
        }
      }, error => {
        delete base.filterObj.typeId;
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  resetSortOrder(sortOrder, columns, column) {
    _.each(columns, function(col) {
      if (col.name != column) {
        sortOrder[col.name] = '';
      }
    });
  }

  listView(clearOldData?) {
    const base = this;
    this.filterObj.display = 'list';
    this.showListView = true;
    this.showGridView = false;
    this.loadingService.triggerLoadingEvent(true);
    this.taskIndex = 0;
    this.tasksTableData.rows = [];
    this.filterObj['typeId'] = [];
    if (this.filterObj && this.filterObj.fromDate) {
      this.filterObj.fromDate = this.filterObj.fromDate ? this.dateFormater.formatDate(this.filterObj.fromDate, this.dateFormat, this.serviceDateformat) : '';
    }
    if (this.filterObj && this.filterObj.toDate) {
      this.filterObj.toDate = this.filterObj.toDate ? this.dateFormater.formatDate(this.filterObj.toDate, this.dateFormat, this.serviceDateformat) : '';
    }
    if (this.searchData.searchKey || !_.isEmpty(this.searchData.advSearchObj)) {
      this.filterObj.searchKey = this.searchData.searchKey;
      this.filterObj.advSearchObj = this.searchData.advSearchObj;
    } else {
      this.filterObj.searchKey = '';
      this.filterObj.advSearchObj = {};
    }
    // if (this.filterObj.company == '' && this.filterObj.assignees.length == 0) {
    //   this.oldFilterObj = _.cloneDeep(this.filterObj);
    //   this.loadingService.triggerLoadingEvent(false);
    //   this.toastService.pop(TOAST_TYPE.error, 'One of Client or Assigned must be selected');
    // } else {
      this.tasksService.clientTasksByPost(this.filterObj, this.taskIndex, this.filterObj.company || [])
        .subscribe(response => {
          delete base.filterObj.typeId;
          if (response && response.tasksList) {
            if (response.tasksList.length <= 0) {
              this.hasNextSet = false;
              this.oldFilterObj = _.cloneDeep(this.filterObj);
              this.taskTableColumns = response.columns;
              this.tasksData = response.tasksList || [];
              this.buildTasksTableData(response.tasksList, true);
              this.loadingService.triggerLoadingEvent(false);
            } else {
              this.hasNextSet = true;
              if (clearOldData) {
                this.tasksTableData.rows = [];
              }
              this.taskIndex = this.taskIndex + response.tasksList.length;
              this.taskTableColumns = response.columns;
              this.tasksData = response.tasksList || [];
              this.buildTasksTableData(response.tasksList, true);
              this.totalCount = response.tasksList.length;
              this.oldFilterObj = _.cloneDeep(this.filterObj);
              this.loadingService.triggerLoadingEvent(false);
            }
          }
        }, error => {
          delete base.filterObj.typeId;
          this.loadingService.triggerLoadingEvent(false);
        });
    // }
  }

  handleListViewScroll(event: NgxScrollEvent) {
    const base = this;
    if (event.isReachingBottom && !base.isLoading && base.hasNextSet && !event.isWindowEvent) {
      base.isLoading = true;
      base.getListTasks();
    }
  }

  getListTasks() {
    const base = this;
    this.filterObj['typeId'] = [];
    if (this.filterObj.type.length > 0) {
      _.forEach(this.filterObj.type, (pref) => {
        const findworkflow = _.find(base.orgTypes, {id: pref});
        if (findworkflow) {
          base.filterObj.typeId.push(findworkflow.workflowId);
        }
      });
    }
    this.loadingService.triggerLoadingEvent(true);
    this.tasksService.clientTasksByPost(this.filterObj, this.taskIndex, this.filterObj.company || [])
      .subscribe(response => {
        delete base.filterObj.typeId;
        this.isLoading = false;
        if (response.tasksList.length <= 0) {
          this.hasNextSet = false;
          this.loadingService.triggerLoadingEvent(false);
        } else {
          this.buildTasksTableData(response.tasksList, false);
          this.taskIndex = this.taskIndex + response.tasksList.length;
          this.hasNextSet = true;
          this.loadingService.triggerLoadingEvent(false);
        }
      }, error => {
        delete base.filterObj.typeId;
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  onKeyUpComapnies($event: string) {
    const base = this;
    if ($event) {
      this.displayCompanies = _.filter(base.clientCompaniesList, function(comp) {
        return comp.name.toLowerCase().indexOf($event.toLowerCase()) != -1;
      });
    } else {
      this.displayCompanies = [];
    }
  }

  onKeyUpAssignees($event) {
    const base = this;
    if ($event && $event.target.value) {
      this.displayUsers = _.filter(base.users, function(user) {
        return user.name.toLowerCase().indexOf($event.target.value.toLowerCase()) != -1;
      });
    } else {
      this.displayUsers = [];
    }
  }

  pageSplit() {
    this.splitPage = !this.splitPage;
    if (this.splitPage) {
      this.pageWidth = '75%';
      this.navigate = false;
    } else {
      this.pageWidth = '37%';
      this.navigate = true;
    }
  }

  onTaskEdited(task) {
    if (this.filterObj.display == 'list') {
      this.listView(true);
    } else {
      this.updateTaskData(task);
    }
  }

  updateStatus($event) {
    this.loadingService.triggerLoadingEvent(true);
    const data = $event.master;
    this.tasksService.patchTaskStatus(data.id, $event.key, {}).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      _.find(this.tasksTableData.rows, function(row) {
        if (row.id === data.id) {
          if ($event.column == 'status') {
            row.status = $event.key;
          }
        }
      });
      this.toastService.pop(TOAST_TYPE.success, 'Status Moved To ' + $event.id);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);

      const message = error && error.message ? error.message : 'Failed To Update Status';
      this.toastService.pop(TOAST_TYPE.error, message);
    });
  }

  exportTasksinList() {
    const base = this;
    this.filterObj['typeId'] = [];
    if (this.filterObj.type.length > 0) {
      _.forEach(this.filterObj.type, (pref) => {
        const findworkflow = _.find(base.orgTypes, {id: pref});
        if (findworkflow) {
          base.filterObj.typeId.push(findworkflow.workflowId);
        }
      });
    }
    this.taskIndex = -1;
    let url = (this.currentEnvironment.production) ? 'https://services.taxplaniq.com' : 'https://dev-services.taxplaniq.com';
    url = url + this.tasksService.clientExportTasks(this.filterObj, this.taskIndex);
    const obj: any = {};
    obj.fileType = 'excel';
    obj.reportName = 'Tasks';
    obj.url = url;
    obj.payload = '';
    obj.method = 'get';
    obj.currency = 'USD';
    obj.dataKey = 'tasksList';
    obj.entityType = 'TASKS_EXPORT';
    this.loadingService.triggerLoadingEvent(true);
    this.reportService.exportTableIntoFile(this.org, this.user ,obj)
      .subscribe(data => {
        delete base.filterObj.typeId;
        this.loadingService.triggerLoadingEvent(false);
        const blob = new Blob([data], {type: 'application/vnd.ms-excel'});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Tasks_${new Date().toISOString().slice(0,10).replace(/-/g,'_')}.xls`;
        link.click();
      }, error => {
        delete base.filterObj.typeId;
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Export Table Into Excel');
      });
  }

  stopPropagation($event) {
    $event && $event.stopImmediatePropagation();
  }

  hideReveal(revealFlag) {
    this.reveal[revealFlag] = false;
    if (revealFlag === 'workProjection') {
      this.loadingService.triggerLoadingEvent(true);
      this.hasTasks = false;
      this.listView();
    }
    if (revealFlag === 'taskCreation') {
      this.resetTaskCreationFields();
    }
    this.invokeChangeDetection();
  }

  moveNextStatus($event) {
    const data = _.find(this.tasksData, {id: $event.row.id});
    data.status = $event.row.status ? $event.row.status.id : data.status;
    this.tasksService.updateTaskStatusOrder(this.org, this.user, $event.row.id, 'list', data)
      .subscribe(response => {
        const index = _.findIndex(this.tasksTableData.rows, {id: $event.row.id});
        if (index !== -1) {
          const rows = this.tasksTableData.rows || [];
          rows[index] = this.createTableRow(response);
          data.status = response.status;
          this.tasksTableData = {...this.tasksTableData, rows};
        }
        this.toastService.pop(TOAST_TYPE.success, `${$event.column.charAt(0).toUpperCase() + $event.column.slice(1)} Updated Successfully`);
      }, error => {

        const message = error.message ? error.message : `Failed To Update ${$event.column.charAt(0).toUpperCase() + $event.column.slice(1)}`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  handleSelect(event) {
    const base = this;
    if (typeof event === 'boolean') {
      this.selectedTableRows = [];
      this.updateDashboardTable(event);
    } else {
      this.handleRowSelection(event);
    }
  }

  handleRowSelection(obj) {
    if (obj) {
      const idx = _.findIndex(this.selectedTableRows, {id: obj.id});
      if (idx === -1) {
        this.selectedTableRows.push(obj);
      } else {
        this.selectedTableRows.splice(idx, 1);
      }
    }
  }

  updateDashboardTable(state) {
    if (state) {
      this.handleRowSelect(this.tasksTableData.rows, state);
    } else {
      this.handleRowSelect([], state);
    }
  }

  handleRowSelect(selectedRows, state) {
    const base = this;
    if (this.tasksTable && this.tasksTable.id) {
      const selectedTableId = this.tasksTable.id;
      jQuery('#' + selectedTableId).find('tbody tr input.checkbox').each(function(idx, cbox) {
        const id = jQuery(this).closest('tr').attr('id');
        const row = _.find(base.tasksTableData.rows, {id: id});
        if (!state) {
          jQuery(cbox).prop('checked', false);
        } else {
          jQuery(cbox).prop('checked', true);
        }
        if (!jQuery(cbox).is(':checked')) {
          _.remove(base.selectedTableRows, {id});
        }
      });
      _.each(selectedRows, function(doc) {
        base.selectedTableRows.push(doc);
      });
      this.selectedTableRows = _.uniqBy(this.selectedTableRows, 'id');
    }
  }

  updateActions() {
    this.actions = [ {
      className: 'ion-calendar',
      name: 'Due Date',
      value: 'duedate'
    }, {
      className: 'ion-stats-bars',
      name: 'Status',
      value: 'status'
    }, {
      className: 'ion-arrow-swap',
      name: 'Priority',
      value: 'priority'
    }, {
      className: 'ion-ios-redo-outline',
      name: 'Assignee',
      value: 'assign'
    }, {
      className: 'ion-ios-undo-outline',
      name: 'Reassign',
      value: 'reassign'
    }, {
      className: 'ion-trash-b',
      name: 'Delete',
      value: 'delete'
    }];
  }

  resetSelectedCheckBoxes() {
    this.selectedTableRows = [];
    this.flagName = '';
    this.flagValue = '';
    this.updateDashboardTable(false);
  }

  handleMultipleActions(value, name) {
    this.flagValue = value;
    this.flagName = name;
    jQuery('#recent-actions').foundation('close');
    if (value === 'time' || value === 'service') {
      this.checkClientType();
      this.setCheckboxesId();
      if (this.selectedRowsClients) {
        this.switchBoard.onDisplayFloatingWindow.next({
          url: ['companies', this.invoiceCompanyId, 'invoices', value, this.invoiceClientId, 'NewInvoice'],
          title: this.invoiceTitle,
          initialView: 'maximized',
          maxmizeStyle: {
            height: '90vh',
            width: '90vw'
          }
        });
        // setTimeout(() => {
        //   this.switchBoard.invoiceActions.next({
        //     invoiceType: value,
        //     ids: this.selectedRowsId,
        //     timeIds: this.selectedRowsId,
        //     type: 'task'
        //   });
        // }, 500);
      } else {
        this.toastService.pop(TOAST_TYPE.warning, 'Selected Clients must be identical');
      }
    } else if (value === 'duedate') {
      this.reveal = {...this.reveal, flag: true};
    } else if (value === 'status') {
      if (this.selectedRowsStatus) {
        this.reveal = {...this.reveal, flag: true};
      } else {
        this.toastService.pop(TOAST_TYPE.warning, 'Selected tasks are all of not the same type');
      }
    } else if (value === 'priority') {
      this.reveal = {...this.reveal, flag: true};
    } else if ((value === 'assign') || (value === 'reassign')) {
      this.reveal = {...this.reveal, flag: true};
    } else if (value === 'delete') {
      this.reveal = {...this.reveal, flag: true};
    }
  }

  checkClientType() {
    const base = this;
    _.forEach(base.selectedTableRows, function(pref) {
      if (base.selectedTableRows[0].clientId === pref.clientId) {
        base.selectedRowsClients = true;
        base.invoiceCompanyId = pref.companyId;
        base.invoiceClientId = pref.clientId;
        base.invoiceTitle = pref.popupTitle;
      } else {
        base.selectedRowsClients = false;
      }
    });
  }

  setCheckboxesId() {
    const base = this;
    const checkboxes = [];
    _.forEach(base.selectedTableRows, function(pref) {
      checkboxes.push(pref.id);
    });
    base.selectedRowsId = checkboxes;
  }

  getCheckedTasks() {
    const taskIds = [];
    this.selectedTableRows.forEach(function(item) {
      taskIds.push(item.id);
    });
    return taskIds;
  }

  onBulkDueDateSelect($event) {
    this.bulkDueDate = $event;
  }

  onBulkStatusSelect($event) {
    if (!_.isEmpty($event)) {
      this.bulkstatusId = $event.id;
    } else {
      this.bulkstatusId = '';
    }
  }

  onBulkPrioritySelect($event) {
    if (!_.isEmpty($event)) {
      this.bulkPriorityId = $event.id;
    } else {
      this.bulkPriorityId = '';
    }
  }

  onBulkAssigneeSelect($event) {
    if (!_.isEmpty($event)) {
      this.bulkAssigneeId = $event.id;
    } else {
      this.bulkAssigneeId = '';
    }
  }

  onSubmit(flagValue) {
    const base = this;
    let obj = {};
    this.loadingService.triggerLoadingEvent(true);
    if (flagValue === 'duedate') {
      obj = {
        type: base.flagName,
        value: base.bulkDueDate,
        taskIds: base.getCheckedTasks(),
      };
    } else if (flagValue === 'status') {
      obj = {
        type: base.flagName,
        value: base.bulkstatusId,
        taskIds: base.getCheckedTasks(),
      };
    } else if (flagValue === 'priority') {
      obj = {
        type: base.flagName,
        value: base.bulkPriorityId,
        taskIds: base.getCheckedTasks(),
      };
    } else if (flagValue === 'assign') {
      obj = {
        type: base.flagName,
        value: base.bulkAssigneeId,
        taskIds: base.getCheckedTasks(),
      };
    } else if (flagValue === 'reassign') {
      obj = {
        type: 'ReAssignee',
        value: base.bulkAssigneeId,
        taskIds: base.getCheckedTasks(),
      };
    } else if (flagValue === 'delete') {
      obj = {
        type: base.flagName,
        value: '',
        taskIds: base.getCheckedTasks(),
      };
    }
    this.tasksService.bulkUpdateInTasks(base.user, base.org, obj)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.resetSelectedCheckBoxes();
        this.listView(true);
        this.toastService.pop(TOAST_TYPE.success, 'Bulk update will be processed shortly');
      }, error => {
        this.handleError(error);
      });
    this.hideReveal('flag');
  }

  handleError(error) {
    this.loadingService.triggerLoadingEvent(false);
    try {

      const message = error && error.message ? error.message : 'Failed To perform action';
      this.toastService.pop(TOAST_TYPE.error, message);
    } catch (error) {
      const message = error && error.message ? error.message : 'Failed To perform action';
      this.toastService.pop(TOAST_TYPE.error, message);
    }
  }

  setRevealWidth(event) {
    if (event) {
      this.revealWidth = '80%';
    } else {
      this.revealWidth = '40%';
    }
  }

  invokeChangeDetection(): void {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  openCreateTaskPopup() {
    this.reveal.taskCreation = true;
  }

  onClientSelect(client) {
    this.selectedClient = client;
    this.getClientPlans(this.selectedClient.id);
  }

  onClientPlanSelect(plan) {
    this.selectedPlan = plan;
    this.getClientPlanStrategiesInfo(this.selectedPlan.id);
  }

  onPlanStrategySelect(strategy) {
    this.selectedPlanStrategy = strategy;
  }

  getClientPlans(clientId) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getPlansForClient(this.org, this.user, clientId)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.clientPlans = _.cloneDeep(response);
      }, (error) => {
        this.isLoading = false;
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  getClientPlanStrategiesInfo(planId){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxPlanStrategiesInfo(this.org, this.user, planId, 'task')
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.planStrategies = response;
        },
        error: (error) => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get plan data');
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  setGoalDate($event){
    if ($event){
      this.taskGoalDate = $event;
    }
  }

  createTask() {
    if (this.validateTaskCreation()) {
      if (this.selectedPlanStrategy && this.selectedPlanStrategy.id) {
        this.loadingService.triggerLoadingEvent(true);
        this.taxPlanningService.createTaskForPlanStrategy(this.org, this.user, this.selectedPlanStrategy.id, this.taskGoalDate)
          .subscribe({
            next: (response) => {
              this.listView();
              this.loadingService.triggerLoadingEvent(false);
              this.toastService.pop(TOAST_TYPE.success, 'Task created successfully');
              this.hideReveal('taskCreation');
            },
            error: (error) => {
              this.toastService.pop(TOAST_TYPE.error, 'Failed to create a task');
              this.loadingService.triggerLoadingEvent(false);
            }
          });
      }
    }
  }

  validateTaskCreation() {
    let isValid = true;
    if (!this.selectedClient) {
      isValid = false;
      this.taskCreationError = 'Please select a client';
      this.toastService.pop(TOAST_TYPE.error, this.taskCreationError);
    } else if (!this.selectedPlan) {
      isValid = false;
      this.taskCreationError = 'Please select a plan';
      this.toastService.pop(TOAST_TYPE.error, this.taskCreationError);
    } else if (!this.selectedPlanStrategy) {
      isValid = false;
      this.taskCreationError = 'Please select a strategy';
      this.toastService.pop(TOAST_TYPE.error, this.taskCreationError);
    } else if (!this.taskGoalDate) {
      isValid = false;
      this.taskCreationError = 'Please select a goal task date';
      this.toastService.pop(TOAST_TYPE.error, this.taskCreationError);
    }
    return isValid;
  }

  resetTaskCreationFields() {
    this.selectedClient = '';
    this.selectedPlan = '';
    this.selectedPlanStrategy = '';
    this.taskGoalDate = '';
  }

}
